import React, { FC, useState } from 'react';
import CustomModal from '../../components/CustomModal';
import ProjectForm from '../../components/ProjectForm/index';
import ImproveTabs from '../../components/ImproveTabs';
import useTranslation from '../../hooks/useTranslation';
import { ProjectTypeModalProps } from '../../models/reusableProps/ProjectTypeModalProps';
import { useTypedSelector } from '../../store';
import { selectResponsibleOptionsList } from '../../store/users/selectors';
import {
  getBusinessUnits,
  getSelectedCountryCodes,
} from '../../store/selectData/selectors';
import { ESTABLISHMENT_TYPE } from '../../components/ProjectTypeSelect/utils';
import { selectConfidentialPermission } from '../../store/userData/selectors';
import {
  createProject,
  fetchSiteLocation,
} from '../../store/projects/actionWrapper';
import { useDispatch } from 'react-redux';
import { returnImproveUnitValidationSchema } from './utils';
import {
  selectSiteLocation,
  selectSolutions,
} from '../../store/projects/selectors';
import { calculateTabErrors } from '../CreateNewUnitModal/utils';
import { stripOfNewId } from '../BulkCreate/utils';

const ImproveProjectModal: FC<ProjectTypeModalProps> = ({
  visible,
  onClose,
  projectsList,
  countries,
  setActiveProject,
}) => {
  const dispatch = useDispatch();
  const t = useTranslation();
  const solutions = useTypedSelector(selectSolutions);
  const isConfidentialAllowed = useTypedSelector(selectConfidentialPermission);
  const usersList = useTypedSelector(selectResponsibleOptionsList);
  const BuList = useTypedSelector(getBusinessUnits);
  const selectedCountryCodes = useTypedSelector(getSelectedCountryCodes);
  const selectedSiteLocation = useTypedSelector(selectSiteLocation);
  const [formModified, setFormModified] = React.useState(false);
  const [selectedCountry, setSelectedCountry] = React.useState('');
  const validation = returnImproveUnitValidationSchema(t);
  const [formErrors, setFormErrors] = useState({});

  const handleCreateProject = (props) => {
    dispatch(
      createProject({
        ...props,
        establishmentType: ESTABLISHMENT_TYPE.IMPROVE,
        solutions: solutions.map(stripOfNewId),
      }),
    );
    onClose();
  };

  const onCountryChange = (country) => {
    setSelectedCountry(country.target.value);
  };

  const onBUChange = (bu) => {
    dispatch(fetchSiteLocation(bu.businessUnitId || ''));
  };

  const BuFiltered = BuList.filter(
    (bu) =>
      bu.countryId === (selectedCountry || selectedCountryCodes[0]?.countryId),
  );

  return (
    <CustomModal
      isVisible={visible}
      onClose={onClose}
      formModified={formModified}
      title={t('projectTypes.improve')}
      useConfirmation
      children={
        <ProjectForm
          onSubmit={handleCreateProject}
          setFormModified={(isDirty) => setFormModified(isDirty)}
          country={selectedCountryCodes[0]?.countryId || ''}
          onClose={onClose}
          submitBtnTitle={t('common.create')}
          validationSchema={validation}
          selectedSiteLocation={selectedSiteLocation}
          projectType={ESTABLISHMENT_TYPE.IMPROVE}
          setFormErrors={setFormErrors}
        >
          <ImproveTabs
            projectsList={projectsList}
            countries={countries}
            setActiveProject={setActiveProject}
            usersList={usersList}
            BuList={BuFiltered}
            onCountryChange={onCountryChange}
            onBUChange={onBUChange}
            isConfidentialAllowed={isConfidentialAllowed}
            tabErrors={calculateTabErrors(formErrors, false)}
          />
        </ProjectForm>
      }
    />
  );
};

export default ImproveProjectModal;
